import { createClient, fetchExchange, subscriptionExchange } from "urql";
import { createUrqlErrorRewriteExchange } from "./urqlErrorRewriteExchange";
import { graphcacheExchange } from "./urqlExchange";
import { getLocalStorage } from "./utils/LocalStorage.utils";
import { wsClient } from "./wsClient";
export const createUrqlClient = (options) => createClient({
    url: import.meta.env.VITE_GRAPHQL_URL || "http://localhost:4000/graphql",
    exchanges: [
        graphcacheExchange,
        createUrqlErrorRewriteExchange(options?.rewriteErrorMessage),
        fetchExchange,
        subscriptionExchange({
            forwardSubscription: (operation) => ({
                subscribe: (sink) => {
                    if (!operation.query) {
                        throw new Error("GraphQL query is required for subscriptions");
                    }
                    return {
                        unsubscribe: wsClient.subscribe({ ...operation, query: operation.query }, sink)
                    };
                }
            })
        })
    ],
    fetchOptions: () => {
        const idToken = getLocalStorage(`${import.meta.env.VITE_SESSION_PREFIX}-id-token`);
        const headers = {};
        if (idToken) {
            headers.Authorization = idToken;
        }
        return {
            headers
        };
    }
});
